/**
 * TimelineGroupToggle Component
 *
 * Grouping strategy toggle buttons.
 * Groups crops by none, species, location, or family.
 */

import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { TpToggleButtonGroup } from '~/components/tp-toggle-button-group'
import { TpToggleButton } from '~/components/tp-toggle-button'
import { TimelineToggleWithPopper } from './timeline-toggle-with-popper'
import {
  useTimelineContextDispatch,
  setGroupStrategy as setGroupStrategyAction,
} from '../../context/timeline-context'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { CONTROLS_BREAKPOINT } from './timeline-controls-constants'
import { TpControlTooltip } from '../../../../../components/tp-control-tooltip'

/**
 * TimelineGroupToggle - Grouping strategy buttons
 *
 * Options:
 * - None: No grouping (all crops listed individually)
 * - Species: Group by template_id
 * - Location: Group by organization_id
 * - Family: Group by family_code
 */
export const TimelineGroupToggle = () => {
  const theme = useTheme()
  const isExpanded = useMediaQuery(theme.breakpoints.up(CONTROLS_BREAKPOINT))
  const { groupStrategy } = useTimelineStaticContext()
  const dispatch = useTimelineContextDispatch()

  const handleChange = (e, newValue) => {
    if (newValue !== null) {
      dispatch(setGroupStrategyAction({ groupStrategy: newValue }))
    }
  }

  if (isExpanded) {
    return (
      <TpControlTooltip title="Group" offsetBottom={-8}>
        <span>
          <TimelineGroupToggleContent {...{ groupStrategy, handleChange }} />
        </span>
      </TpControlTooltip>
    )
  }

  return (
    <TimelineToggleWithPopper
      title="Group"
      icon={<Icons.CategoryTwoTone fontSize='small' />}
    >
      <TimelineGroupToggleContent {...{ groupStrategy, handleChange }} />
    </TimelineToggleWithPopper>
  )
}

const TimelineGroupToggleContent = (props) => {
  return (
    <TpToggleButtonGroup
      exclusive
      value={props.groupStrategy}
      onChange={props.handleChange}
      sx={{
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <TpToggleButton value="none">None</TpToggleButton>
      <TpToggleButton value="species">Species</TpToggleButton>
      <TpToggleButton value="location">Location</TpToggleButton>
      <TpToggleButton value="family">Family</TpToggleButton>
    </TpToggleButtonGroup>
  )
}
